<template>
    <app-stepper-section label="Acesso" half-width>

        <v-text-field label="Login(E-mail válido)"
                      v-model="login"></v-text-field>

        <v-text-field label="Senha"
                      v-model="password"
                      v-if="dataShowPassword"></v-text-field>

    </app-stepper-section>
</template>

<script>
    import AppStepperSection from '../../../StepperSection'

    export default {
        components: {
            AppStepperSection
        },

        props: {
            value: {
                type: Object
            },

            dataShowPassword: {
                type: Boolean,
                default: true
            },
        },

        computed: {

            login: {
                get() {
                    return this.value.login
                },
                set(login) {
                    this.$emit('input', {...this.value, login})
                },
            },

            password: {
                get() {
                    return this.value.password
                },
                set(password) {
                    this.$emit('input', {...this.value, password})
                },
            },

        },
    }
</script>

<style scoped>

</style>
